import { Box } from "@remo-co/ui-core/src/components/Box";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Loader } from "@remo-co/ui-core/src/components/Loader";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import {
  getUserForceMoveCountDown,
  updateEventUserNotification,
} from "services/firebaseService/eventUserNotifications";
import {
  BUFFER_COUNT_DOWN,
  EventUserNotificationType,
} from "modules/userForceMove/constants";
import { selectUserForceMoveData } from "modules/userForceMove/redux/selectors";
import { useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import {
  setUserForceMove,
  setShowUserForceMovePopup,
} from "modules/userForceMove/redux/slice";
import { useAppDispatch } from "store/hooks";
import { selectUserId } from "modules/auth/redux/selectors";
import { selectCurrentTheaterId } from "modules/theater/selectors";
import { useFloorNames } from "modules/floors/hooks/useFloorNames";
import { useStyles } from "./styles";

export const UserForceMoveTimer = () => {
  const { t } = useI18n(["conversation", "event"]);
  const styles = useStyles();
  const userForceMoveData = useSelector(selectUserForceMoveData);
  const currentUserId = useSelector(selectUserId);
  const currentTheaterId = useSelector(selectCurrentTheaterId);
  const floorNames = useFloorNames(currentTheaterId);
  const dispatch = useAppDispatch();
  const initialCountDown = useMemo(
    () =>
      userForceMoveData
        ? getUserForceMoveCountDown(userForceMoveData.createdAt)
        : BUFFER_COUNT_DOWN,
    [userForceMoveData],
  );
  const [countDown, setCountDown] = useState(initialCountDown);

  useEffect(() => {
    const interval = setInterval(() => {
      if (countDown === 0) {
        dispatch(setShowUserForceMovePopup(false));
        dispatch(setUserForceMove(true));
        clearInterval(interval);
        return;
      }
      setCountDown((count) => count - 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [countDown, dispatch]);

  const handleMoveImmediate = () => {
    updateEventUserNotification({
      type: EventUserNotificationType.IMMEDIATE_MOVE,
    });

    dispatch(setShowUserForceMovePopup(false));
  };

  if (!userForceMoveData || userForceMoveData?.userId !== currentUserId) {
    return null;
  }

  return (
    <Container className={styles.container} data-testid="user-move-timer">
      <Box className={styles.messageBox}>
        <Typography className={styles.message} variant="h4">
          {t("conversation:force.move.attendee.message", {
            name: userForceMoveData.eventManagerName,
            floorName:
              floorNames[userForceMoveData.targetFloorId] ||
              userForceMoveData.floorName,
            tableName: userForceMoveData.tableName,
          })}
        </Typography>
      </Box>
      <Box sx={{ width: "100%" }} className={styles.countDownBox}>
        <Typography className={styles.countDown}>{countDown}</Typography>
        <Loader size={70} thickness={2} />
      </Box>
      <Box className={styles.wrapConversation}>
        <Typography variant="body1">
          {t("event:user.move.wrap.up.your.conversations")}
        </Typography>
      </Box>
      <Box className={styles.moveBox}>
        <Button
          color="blue"
          size="sm"
          variant="secondary"
          className={styles.moveButton}
          onClick={handleMoveImmediate}
          data-testid="immediate-move-button"
        >
          {t("conversation:immediate.move")}
        </Button>
      </Box>
    </Container>
  );
};
